<template>
  <div class="client-bid-or-buy p-3 p-md-4">
    <div class="black">
      <div v-if="selectedBid">
        <div class="client-content">
          <!-- Header -->
          <div class="client-header mb-3 text-center text-md-start">
            <!-- <h5 class="client-title">{{ selectedBid.cusip }}</h5> -->
          </div>
               <div class="">
            <div class="bond-info mb-3">
              <span class="info-chip cusip">
                <label>CUSIP</label>{{ selectedBid.cusip }}
              </span>

              <span class="info-chip description">
                <label>Description</label>
                {{ selectedBid.description || selectedBid.issuer }}
              </span>

              <span class="info-chip coupon">
                <label>Coupon</label>
                {{ selectedBid.coupon | percent(3) }}
              </span>

              <span class="info-chip maturity">
                <label>Maturity</label>
                {{ selectedBid.maturityDate }}
              </span>

              <span class="info-chip callable">
                <label>Callable</label>
                {{
                  selectedBid.callDate && selectedBid.callPrice
                    ? `${selectedBid.callDate} @ ${selectedBid.callPrice}`
                    : 'No'
                }}
              </span>
              <span class="info-chip rating">
                <label>Rating</label>
                {{ selectedBid.ratingSP || '—' }}
              </span>
              <span
                class="info-chip bank"
              
              >
                <label>insurance </label>
                {{ selectedBid.bondInsurer ? selectedBid.bondInsurer : 'N/A' }}
              </span>
            </div>
          </div>
    

          <div class="row mb-4 align-items-end">
            <div class="col d-flex flex-column">
              <label class="form-label">Quantity Available</label>
              <input type="number" class="form-control" :value="offerQuantityAvailable" disabled />
            </div>
             <div class="col d-flex flex-column">
              <label class="form-label">{{bidType == 'BID' ? 'Enter Quantity to Bid' : 'Quantity you wish to Buy'}}</label>
              <input type="number" @change="calcuteProceeds" class="form-control" v-model.number="offerQuantity" />
            </div>

            <div class="col d-flex flex-column">
              <label class="form-label">{{ bidType == 'BID' ? 'YOUR BID PRICE ($)' : 'PRICE ($)' }}  </label>
              <input type="text" class="form-control" @change="calcuteProceeds"   :disabled="bidType === 'BUY'" v-model.number="offerPrice" />
            </div>

            <div class="col d-flex flex-column">
              <label class="form-label">Settlement</label>
              <input type="text" class="form-control" disabled v-model="selectedBid.settlementDate" />
            </div>

            <!-- Calc Proceeds -->
            <div class="col-auto d-flex">
              <button  class="btn btn-outline-primary btn-calc" @click="calcuteProceeds" :disabled="!selectedBid.askQty || !offerPrice">
                Calc Proceeds
              </button>
            </div>
          </div>

          <!-- Proceeds -->
          <div v-if="calculatedProceeds" class="row values mt-4">
            <div class="col-6 col-md-2 mb-3">
              <span class="label">PRINCIPAL</span>
              <span class="value">{{
                calculatedProceeds.principal | currency
              }}</span>
            </div>
            <div class="col-6 col-md-2 mb-3">
              <span class="label">ACCRUED</span>
              <span class="value">{{
                calculatedProceeds.accrued | currency
              }}</span>
            </div>
            <div class="col-6 col-md-2 mb-3">
              <span class="label">NET MONEY</span>
              <span class="value">{{
                calculatedProceeds.proceeds | currency
              }}</span>
            </div>
            <div class="col-6 col-md-2 mb-3">
              <span class="label">YTW</span>
              <span class="value">{{
                calculatedProceeds.ytw
              }}%</span>
            </div>
            <div class="col-6 col-md-2 mb-3">
              <span class="label">YTM</span>
              <span class="value">{{
                calculatedProceeds.ytm
              }}%</span>
            </div>
            <div class="col-6 col-md-2 mb-3">
              <span class="label">YTC</span>
              <span class="value">{{
                calculatedProceeds.ytc
              }}%</span>
            </div>
          </div>
<div class="text-center mt-4">
          <button
            class="btn bid-btn"
            :disabled="isSubmitting || !selectedBid.askQty || !offerPrice"
            @click="sendBidOrBuy"
          >
            <span v-if="!isSubmitting">{{ bidType }}</span>

            <span v-else class="btn-loader">
              <span class="dot"></span>
              <span class="dot"></span>
              <span class="dot"></span>
            </span>
          </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config'
// import authService from '@/authService'

export default {
  name: 'ClientBidOrBuy',

  data () {
    return {
      selectedBid: null,
      bidType: null,
      offerPrice: null,
      offerQuantity: null,
      calculatedProceeds: null,
      isSubmitting: false,
      offerQuantityAvailable : null,
    }
  },

  methods: {
    sendBidOrBuy () {
      if(this.selectedBid.minQuantity && this.offerQuantity < this.selectedBid.minQuantity ) {
        this.$alert(`Minimum quantity for this offering is ${this.selectedBid.minQuantity }. Please adjust your quantity.`, '', 'error')
        return;
      }
      this.isSubmitting = true
      let url = config.baseUrlAutoBidder + '/offering-feed-public/client-bid'
      let body = {
        userId: null,
        cusip: this.selectedBid.cusip,
        quantity: this.offerQuantity,
        price: this.offerPrice,
        offerPrice: this.selectedBid.askPx,
        status: 'PENDING',
        bidType: this.bidType,
        offeringFeedHitId: this.selectedBid.id,
        cusipId: this.selectedBid.cusipId,
        offerQuantity: this.selectedBid.askQty,
        ecn: this.selectedBid.ecn,
        cusipDescription : this.selectedBid.description,
        
      }
      this.$http
        .post(url, body , { headers: { 'client-token': this.$route.query.token } })
        .then(() => {
          this.isSubmitting = false
          this.$alert(
            `Your ${
              this.bidType == 'BUY' ? 'Order' : 'Bid'
            } has been received and currently being processed.`,
            '',
            'success'
          )

        }).catch(() => {
          this.isSubmitting = false
        })
    },
    getBidDetails () {
      let url =
        config.baseUrlAutoBidder +
        '/offering-feed-public/verification'
      this.$http.post(url, {}, { headers: { 'client-token': this.$route.query.token } }).then(res => {
        this.selectedBid = res.data.details;
        this.offerPrice = this.selectedBid.askPx;
        this.offerQuantityAvailable = this.selectedBid.askQty;
        const isBid = this.$route.path.includes('public-bid')
        const isBuy = this.$route.path.includes('public-buy')
        this.bidType = isBid ? 'BID' : isBuy ? 'BUY' : null
      })
    },
    convertToPercentage (val) {
      return `${(val * 100).toFixed(3)}%`
    },
    calcuteProceeds () {
      let url = config.baseUrlAutoBidder + '/offering-feed-public/proceeds';
      // {"cusip":"01170PDV5","quantity":150,"price":100, "token":"fhgfghffjf"}
      let body = {
        cusip: this.selectedBid.cusip,
        price: this.offerPrice,
        quantity: this.offerQuantity,
        settlementDate: this.selectedBid.settlementDate
          ? this.moment(this.selectedBid.settlementDate).format('YYYY-MM-DD')
          : null
      }
      this.$http.post(url, body , { headers: { 'client-token': this.$route.query.token } }).then(res => {
        this.calculatedProceeds = res.data.details
      })
    }
  },
  mounted () {
    this.getBidDetails()
  }
}
</script>
<style scoped>
.client-bid-or-buy {
  background-color: #000203;
}

.black {
  background: #161529;
  border-radius: 10px;
  border: 1px solid #303030;
  padding: 16px;
}

.client-title {
  color: #fff;
  font-size: 16px;
}

label {
  color: #f1f1f1;
  font-size: 13px;
}

.small-text {
  font-size: 13px;
  line-height: 1.5;
}

.values .label {
  display: block;
  font-size: 11px;
  opacity: 0.7;
  color: #ccc;
}

.values .value {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}

@media (min-width: 768px) {
  .black {
    padding: 20px;
  }
}

/* Calc Proceeds */
.calc-btn {
  width: 100%;
  height: 38px; /* same as Bootstrap input */
}

/* BID button */
.bid-btn {
  width: 100%;
  height: 44px;
  background-color: #57b78c !important; /* green */
  border-color: #57b78c !important;
  color: #fff;
  font-weight: 600;
}

/* Desktop behavior */
@media (min-width: 768px) {
  .calc-btn {
    width: auto;
    padding: 6px 16px;
  }

  .bid-btn {
    width: auto;
    padding: 8px 28px;
  }
}


.btn-loader {
  display: inline-flex;
  gap: 6px;
  align-items: center;
}

.btn-loader .dot {
  width: 6px;
  height: 6px;
  background: #ffffff;
  border-radius: 50%;
  animation: pulse 1.4s infinite ease-in-out;
}

.btn-loader .dot:nth-child(2) {
  animation-delay: 0.2s;
}
.btn-loader .dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes pulse {
  0% { opacity: 0.3; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.5); }
  100% { opacity: 0.3; transform: scale(1); }
}


.bond-info {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  /* background: #1b1e2b; */
  padding: 12px 16px;
  border-radius: 8px;
  justify-content: center;
}

.info-chip {
  display: flex;
  gap: 6px;
  align-items: center;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 13px;
  background: rgba(255, 255, 255, 0.08);
  color: #e5e7eb;
  min-width: 150px;
}

.info-chip label {
  font-weight: 600;
  color: #9ca3af;
  font-size: 12px;
}

/* Accent colors */



/* Bank qualified state */


.bond-card {
  background: linear-gradient(180deg, #0f172a, #020617);
  border: 1px solid #1e293b;
  border-radius: 14px;
  padding: 16px 18px 18px;
  color: #e5e7eb;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.45);
}

.bond-card-header {
  font-size: 15px;
  font-weight: 600;
  color: #38bdf8;
  margin-bottom: 14px;
  letter-spacing: 0.3px;
}

.bond-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
}

.info-chip {
  background: rgba(30, 41, 59, 0.65);
  border: 1px solid #334155;
  border-radius: 10px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
}

.info-chip label {
  font-size: 11px;
  color: #94a3b8;
  margin-bottom: 4px;
  text-transform: uppercase;
}

.info-chip span {
  font-size: 14px;
  font-weight: 600;
  color: #f8fafc;
}

/* Special accents */
.info-chip.cusip span {
  color: #22d3ee;
  font-family: monospace;
}





.client-bid-or-buy input {
      background: #272641;
    border: 1px solid #373455;
    box-shadow: none;
    border-radius: 5px;
    padding: 8px;
    outline: none;
    color: #fff;
    font-weight: 400;
    font-size: 13px;
    display: block;
    width: 100%;
}
.btn-calc {
   width: auto;
    color: #fff;
    padding: 5px 25px;
    border-radius: 5px;
    min-width: auto;
    font-weight: 400;
}

</style>
